
import React, { Suspense, useState, useEffect, useRef } from "react";
import WizardServices from "./WizardServices";
import ContactSummary from "./contactSummary";
import SocietyList from "../Common/SocietyList";

export default function ContactWizardSocieties(MainWizard: any) {
    
    const [save, setsave] = useState(false); 
    const [unfield, setunfield] = useState(false);
    const [deleteData, setdelete] = useState(false);      
    const formValidation = useRef<HTMLDivElement>(null);
    const [contactInfo, initContactInfo] = useState<any>([]);
    const [SocietyListOpen, setSocietyListOpen] = useState(false);
    const [societyDetails, initsocietyDetails] = useState<any>([]);
    const [SocietiesDetails, initSocietiesDetails] = useState<any>([]);
    const [totalRowsipiSocieties, settotalRowsipiSocieties] = useState(0);

    var payload = {
        kontactCode: MainWizard.data.code,
        pageNumber: 1,
        pageSize: 10
    }
    useEffect(() => {
        if(MainWizard.data.code){
            apiCall();
        }

    }, []);

    const apiCall =()=> {
        WizardServices.contactInfo(MainWizard.data.code).then((res) => {
            initContactInfo(res)
        })
        WizardServices.kontacts_IPIdetails(payload).then((res) => {
            initSocietiesDetails(res);
            settotalRowsipiSocieties( res && res[0] && res[0].totalRows? res[0].totalRows : 0 )
        }) 
    }

    const onIPISocietyEdit = (e:any) =>{
        console.log(e)
        initsocietyDetails(e)
    }

    const addSocietieyIPI = () =>{
        console.log(societyDetails) ;
 
        var validSave = handleFieldRequired(societyDetails) ; 
        if(validSave){
            
            WizardServices.SocietiesSave(societyDetails).then((res) => { 
                setsave(true);
                clearSForm();
                apiCall();
            }) 
        }else{
            setunfield(true)
        }
        setTimeout(function(){
            setsave(false)
            setunfield(false)
        }, 3000);  

    }

    const handleFieldRequired = (object :any ) => { 
        const inputs :any  = formValidation.current?.querySelectorAll('input');
        var valid = true;               
        
        Object.values(inputs).map((values :any) => {
            const isRequired = document.getElementById(values.id)?.hasAttribute('required');
            
            if(isRequired) { 
                if(!object[values.id]) { 
                    var fieldName : any  = document.getElementById(values.id);
                    fieldName.style.border = "1px solid #ff0000";
                    valid = false;
                }
            }

        } )

        return valid;
    }

    const handleFieldChange = (e :any) => {

        var Field_name = e.target.name;
        var Field_value = e.target.value;
        var Field_type = e.target.type;       
        
        console.log( Field_value)
        console.log( Field_type)
        if( Field_type === "checkbox"){
            Field_value = !Field_value;
        }
        const containsPeriod = Field_name.includes('.');
        
        let updatedObject = { ...societyDetails };

        if (containsPeriod) {
            const parts = Field_name.split('.');

            let currentLevel = updatedObject;
            for (let i = 0; i < parts.length; i++) {
                if (i < parts.length - 1) {
                    if (!currentLevel[parts[i]]) {
                        currentLevel[parts[i]] = {};
                    }
                    currentLevel = currentLevel[parts[i]];
                } else {
                    currentLevel[parts[i]] = Field_value;
                }
            }
        } else {
            updatedObject[Field_name] = Field_value;
        } 

        console.log(updatedObject);
        initsocietyDetails(updatedObject);
    };

    const clearSForm = () =>{
        initsocietyDetails([])
        const inputs :any  = formValidation.current?.querySelectorAll('input');
        Object.values(inputs).map((values :any) => {            
            var fieldName : any  = document.getElementById(values.id);
            fieldName.style.border = "1px solid #47529d";            
         
        } )
    }  
    
    const deleteSociety = (e:any) =>{
        console.log(e)
        WizardServices.SocietiesDelete(e.kontacts_IPI_Id).then((res) => { 
            setdelete(true);
            apiCall();
        }) 
        setTimeout(function(){
            setsave(false)
        }, 3000); 
    }

    const closeSocietyList = (e:any) =>{
        setSocietyListOpen(false);
    }
    const allSocietySelect = (e:any) =>{
        console.log(e)
        societyDetails.affiliation = e.useCode;
        initsocietyDetails(societyDetails)
    }
    
    return (

        <>
        <div className="ws-12">

            <div className="w-65">

                <div className="ws-12 ps">
                    <div className="box">
                        <div className="box-header"> <h1>Societies</h1> </div>

                        <div className="box-content allowVscroll" style={{marginLeft: "4%;"}}>
                            <div className="row-fluid">

                                {unfield && <div className="alert alert-danger ws-11" > There was a problem submitting your request, one or more fields are missing or incorrect.</div>}

                                <div className="row-fluid" ref={formValidation}>
                                    <div className="form-format ws-12">
                                        
                                        <div className="form-format ws-12 mt">
                                            <label className="control-label">Society*</label>

                                            <div className="label-entries">
                                                <div className="w-90">
                                                    <input type="text" id="affiliation" name="affiliation" value={societyDetails.affiliation ? societyDetails.affiliation:""} 
                                                        required placeholder="Society" onChange={(e)=>handleFieldChange(e)} defaultValue={""}/>
                                                </div>
                                                <div className="w-10">
                                                    <button className="icon-btn edit" id="btnMechSociety" onClick={()=>setSocietyListOpen(true)}>
                                                        <i className="icon-search"></i>
                                                    </button>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="form-format ws-12 mt">
                                            <label className="control-label">IPI/CAE Number*</label>

                                            <div className="label-entries">
                                                <input type="text" id="iPNumber" defaultValue={""} value={societyDetails.iPNumber ? societyDetails.iPNumber:""} 
                                                    name="iPnumber" required placeholder="IPI/CAE Number" onChange={(e)=>handleFieldChange(e)} />
                                            </div>
                                        </div>

                                        <div className="form-format ws-12 mt">
                                            <label className="control-label">Contact(AKA)</label>

                                            <div className="label-entries">
                                                <input type="text" id="knownAs" value={societyDetails.knownAs ? societyDetails.knownAs:""} 
                                                    onChange={(e)=>handleFieldChange(e)} name="knownAs" placeholder="Contact(AKA)" />
                                            </div>
                                        </div>

                                        <div className="form-format ws-12 mt">
                                            <label className="control-label">Guilds</label>
                                            <div className="label-entries">
                                                <input type="text" id="guilds" value={societyDetails.guilds ? societyDetails.guilds:""} 
                                                    onChange={(e)=>handleFieldChange(e)} name="guilds" placeholder="Guilds" />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                
                            </div>
                        </div>                        

                        <div className="box-footer pts">
                            <a  className="icon-btn edit" onClick={()=>addSocietieyIPI()}> <i className="icon-save"></i> Save </a>
                            <a  className="btn btn-pink" onClick={()=>clearSForm()}> <i className="icon-refresh"></i> Reset </a>

                        </div>
                    </div>
                </div>

                <div className="ws-12 ps">
                    <div className="box">
                        <div className="row-fluid">
                            <div className="ws-12">
                                <div className="box-header well mb"> <h2> {totalRowsipiSocieties} record(s) found </h2> </div>
                                {save && <div className="alert alert-success"> Details for  has been saved successfully </div>}
                                {deleteData && <div className="alert alert-success">Contact deleted successfully</div>}
                                
                                <div className="control-group ps">
                                    {(totalRowsipiSocieties === 0) && <div className="alert alert-info"> No records to display </div>}
                                    {(totalRowsipiSocieties > 0) &&<div className="table-responsive">
                                        <table className="newTable">
                                            <thead>
                                                <tr>
                                                    <th >Society</th>
                                                    <th >IPI/CAE Number</th>
                                                    <th >Contact(AKA)</th>
                                                    <th >Guilds</th>
                                                    <th >Operation</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {SocietiesDetails?.map( (values :any)=>{
                                                    return ( 
                                                    <tr >
                                                        <td > {values.affiliation}</td>
                                                        <td > {values.iPNumber}</td>
                                                        <td > {values.knownAs}</td>
                                                        <td > {values.knownAs}</td>

                                                        <td >
                                                            <a onClick={()=>onIPISocietyEdit(values)} className="icon-btn edit btn-sm"> <i className="icon-edit"></i> </a>
                                                            <a onClick={()=>deleteSociety(values)}className="icon-btn delete btn-sm"><i className="icon-close"></i></a>
                                                        </td>
                                                    </tr>
                                                )} )}
                                            </tbody>
                                        </table>
                                    </div>}                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    
            <div className="w-35 ps ">
                <ContactSummary data={contactInfo}/>
            </div>

            {
                (() => {

                    if(SocietyListOpen){
                        return <SocietyList open={SocietyListOpen} closeSocietyList={closeSocietyList} allSocietySelect={allSocietySelect}/>
                    }                                                  

                })()                        
            }
        </div>
        </>
    )

}